// Single source of truth for the Golf Elite brand — the platform's default
// brand. Colors + logo + name live here ONCE so nothing drifts. PBCC and Golf
// Hustler keep their own values in club.js; this file only defines Golf Elite.
//
// Node-safe: tailwind.config.js imports club.js, which imports this file. The
// logo is resolved with `new URL(...)` (NOT a static PNG import), so evaluating
// this module in the Node/Tailwind context never reads from disk and never
// requires the image to exist at config-load time.
export const GOLF_ELITE_LOGO = new URL('../assets/brand/golf-elite-logo.png', import.meta.url).href

// The one Golf Elite token set. Every surface pulls its brand values from here
// (directly, or through the CSS variables defined in styles.css that mirror it).
export const GOLF_ELITE = {
  name: 'Golf Elite',
  shortName: 'Golf Elite',

  // Core
  primary: '#16233C',      // navy — headers, nav, dark hero
  primaryDeep: '#0E1A2E',  // deeper navy
  accent: '#2E6FE6',       // accent blue — buttons, links, active/highlight
  accentHover: '#2358C6',
  accentDark: '#2358C6',
  accentTint: '#E9F1FD',

  // Text
  ink: '#16233C',
  body: '#48566B',
  muted: '#6B7686',

  // Backgrounds
  bg: '#FFFFFF',
  panel: '#F4F6FA',
  line: '#E3E8EF',

  // Status
  live: '#22A06B',   // live / green
  alert: '#D6483E',  // alert / under-par red

  logo: GOLF_ELITE_LOGO,
}

export default GOLF_ELITE
